<fcom-button
  *ngIf="showButton$ | async"
  [class]="'login-btn'"
  data-testid="finnair-plus-login-button"
  [finElemTracker]="(loginStatus$ | async) !== LoginStatus.LOGGED_IN ? 'open-login' : 'open-profile'"
  [finElemContext]="trackingContext"
  [finElemType]="ElementTypes.BUTTON"
  [aria]="{
    label:
      ((loginStatus$ | async) !== LoginStatus.LOGGED_IN ? 'login.openLogin' : 'login.displayProfile') | finLocalization,
    role: 'button',
  }"
  [icon]="{
    name: icon$ | async,
    position: IconPosition.LEFT,
  }"
  [text]="
    (isMobile$ | async)
      ? ''
      : showName && (loginStatus$ | async) === LoginStatus.LOGGED_IN
        ? (profileName$ | async)
        : showName
          ? ('navigation.login' | finLocalization)
          : ''
  "
  [mode]="ButtonMode.INLINE"
  [theme]="ButtonTheme.LIGHT_TERTIARY_GHOST"
  data-hj-suppress
/>
